export type Validity = [boolean, string]

export const noValidation: () => Validity = () => [true, '']

export const validateRequiredOption = (message: string) => (value: string): Validity => {
  if (value === '') {
    return [false, message]
  }

  return [true, '']
}
